import { ContentWidgetDialogPurpose } from '../../../model/enumerations';
import template from './dialog-view.component.html';
import { EventCodes } from '../../../../../App/model/event-codes';

export const MxDialogViewComponent = {
	bindings: {
		view: '<',
	},
	controller: MxSolutionBuilderAgentEditCtrl,
	controllerAs: 'vm',
	template: template,
};

MxSolutionBuilderAgentEditCtrl.$inject = [
	'mx.shell.EventService',
	'mx.shell.DetailsView',
	'mx.shell.SidePanelService',
	'mx.internationalization',
	'mx.SolutionBuilderAgent.DialogOpenerService',
	'mx.shell.UserProfileService',
	'$scope',
];

function MxSolutionBuilderAgentEditCtrl(eventService, MxDetailsView, sidePanelService, i18n, dialogOpener, userProfile, $scope) {
	const vm = this;
	const defaultDoneLabel = i18n.get('shell.common.done');
	vm.sidePanelService = sidePanelService;

	vm.loaded = false;

	userProfile.get().then(function (user) {
		vm.user = user;
	});

	vm.openNewDialog = function () {
		switch (vm.view.dialogType) {
			case mx.SolutionBuilderAgent.ContentWidgetDialogAction.Preview:
				dialogOpener.openNewDialog('PDRContentWidgetTypeObjectDetails');
				break;
			case mx.SolutionBuilderAgent.ContentWidgetDialogAction.Edit:
				dialogOpener.openNewDialog('PDRContentWidgetTypeDialog');
				break;
		}
	};

	vm.$onInit = () => {
		vm.contentWidgetId = vm.view.widgetId;
		vm.objectId = vm.view.context?._id || 'new';
		vm.dialogType = vm.view.dialogType;

		vm.isEditableDialog =
			vm.view.dialogType === mx.SolutionBuilderAgent.ContentWidgetDialogAction.Edit || vm.view.dialogType === mx.SolutionBuilderAgent.ContentWidgetDialogAction.New;
		vm.enableConcurrencyTracking = vm.view.dialogType === mx.SolutionBuilderAgent.ContentWidgetDialogAction.Edit;

		setDoneButtonLabel(defaultDoneLabel);
		vm.isSaveVisible = vm._isSaveVisible = vm.isEditableDialog && vm.view.purpose !== ContentWidgetDialogPurpose.CreateOnly;

		eventService.subscribeTo(
			mx.SolutionBuilderAgent.Events.ViewDataLoaded,
			function (e, view) {
				if (view === vm.view) {
					vm.loaded = true;
				}
			},
			$scope
		);
	};

	vm.saveAndClose = saveAndClose;
	vm.save = save;
	vm.cancel = cancel;

	vm.hideSaveButton = hideSaveButton;
	vm.setDoneButtonLabel = setDoneButtonLabel;

	return vm;

	function setDoneButtonLabel(label) {
		vm.doneLabel = typeof label === 'string' && label ? label : defaultDoneLabel;
	}

	function hideSaveButton(value) {
		vm._isSaveHidden = Boolean(value);
		vm.isSaveVisible = vm._isSaveVisible && !vm._isSaveHidden;
	}

	function cancel() {
		trackTelemetry('cancel clicked');

		if (sidePanelService.isViewUnsafeForClosing(vm.view)) {
			var dialogConfig = {
				id: 'ActionOnSafeCancelDialog',
				title: i18n.get('shell.mx-side-panel-service.unsavedData'),
				actions: [
					{
						id: 'cancel',
						notForSave: true,
						title: i18n.get('shell.mx-side-panel-service.doNothing'),
					},
					{
						id: 'close',
						title: i18n.get('solutionBuilderAgent.services.side-panel-service.close'),
					},
					{
						id: 'save-and-close',
						notForSave: true,
						disabled: vm.view.saveDisabled,
						title: i18n.get('solutionBuilderAgent.services.side-panel-service.save-and-close'),
					},
				],
			};

			return {
				execute: sidePanelService.showConfirmationDialog(dialogConfig).then(function (answer) {
					if (answer === 'close') {
						eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.DialogActionExecuted, {
							view: sidePanelService.currentView,
							action: 0,
						});
					} else if (answer === 'save-and-close') {
						eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.DialogActionExecuted, {
							view: sidePanelService.currentView,
							action: 2,
						});
					}
				}),
			};
		} else {
			return {
				execute: eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.DialogActionExecuted, {
					view: sidePanelService.currentView,
					action: 0,
				}),
			};
		}
	}

	function trackTelemetry(eventName) {
		try {
			eventService.dispatchEvent(EventCodes.TrackViewTelemetry, { eventName: `{viewName} ${eventName}`, view: vm.view });
		} catch (e) {
			//do nothing
		}
	}

	function save() {
		trackTelemetry('save clicked');
		eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.DialogActionExecuted, {
			view: vm.view,
			action: 1,
		});
	}

	function saveAndClose() {
		trackTelemetry('done clicked');
		eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.DialogActionExecuted, {
			view: vm.view,
			action: 2,
		});
	}
}
